import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { InputGroupModule } from '@forms/input-group/input-group.module';
import { NgStackFormsModule } from '@ng-stack/forms';
import { ImageFieldComponent } from './image-field.component';

@NgModule({
  declarations: [ImageFieldComponent],
  imports: [CommonModule, InputGroupModule, NgStackFormsModule],
  exports: [ImageFieldComponent],
})
export class ImageFieldModule {}
